module.exports = __webpack_public_path__ + "img/login_img.c0defae8.png";